module.exports = __webpack_public_path__ + "static/media/Interaction2.35c38d71.svg";